
import React from 'react';

import HelpPageFooterNotice from '../components/helpPageFooterNotice';

const TripsMonitoredReportHelp = () => {
  return (
    <>
      <h1>Trips Monitored Report</h1>
      <p>
        This reporting tool gives you the ability to view the number of trips
        that were monitored and/or received messages for your account over a
        given time period. Simply select from one of the defaults or choose a
        custom date range to download your report. On clicking
        &quot;DOWNLOAD&quot; you will be prompted to download the report as a
        CSV file.
      </p>
      <ul>
        <li>
          Note: There is a two-day processing delay to account for worldwide
          time calculations.
        </li>
      </ul>
      <HelpPageFooterNotice />
    </>
  );
};
export default TripsMonitoredReportHelp;
